import { NetworkAvalancheCoins } from '../networkBaseTokens';
export function getAvalancheCoin(_a) {
    var network = _a.network;
    var avalanchecoin = NetworkAvalancheCoins.get(network);
    if (!avalanchecoin) {
        // throw new Error(`Unsupported network ${network}`);
        return null;
    }
    return avalanchecoin;
}
